import { render, staticRenderFns } from "./coin-transfer-header.vue?vue&type=template&id=06e95e86"
import script from "./coin-transfer-header.vue?vue&type=script&lang=js"
export * from "./coin-transfer-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports